import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/kiss-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M168 152C144.2 152 115.3 181.3 112 223.4 111.7 227.1 114 230.6 117.6 231.7 121.1 232.7 125.1 231.2 126.9 228L136.4 211C144.1 197.3 155.6 189.4 167.9 189.4S191.7 197.3 199.4 211L208.9 228C211 231.7 215.1 232.7 218.2 231.7 221.8 230.6 224.1 227.2 223.8 223.4 220.7 181.3 191.8 152 168 152zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM304 308C304 288.8 275.2 266.5 232.5 264 228.7 263.6 225.1 266.4 224.3 270.2 223.4 274 225.4 277.9 229 279.4L245.9 286.6C258.9 292.1 266.7 300.1 266.7 308.1S258.9 324.1 246 329.6L229 336.8C223.3 339.2 223 349 229 351.6L245.9 358.8C258.9 364.3 266.7 372.3 266.7 380.3S258.9 396.3 246 401.8L229 409C225.4 410.5 223.4 414.4 224.3 418.2 225.1 421.8 228.4 424.4 232.1 424.4H232.6C275.4 421.9 304.1 399.6 304.1 380.4 304.1 367.4 290.7 353.1 268.9 344.4 290.6 335.3 304 321 304 308zM328 152C304.2 152 275.3 181.3 272 223.4 271.7 227.1 274 230.6 277.6 231.7 281.1 232.7 285.1 231.2 286.9 228L296.4 211C304.1 197.3 315.6 189.4 327.9 189.4S351.7 197.3 359.4 211L368.9 228C371 231.7 375.1 232.7 378.2 231.7 381.8 230.6 384.1 227.2 383.8 223.4 380.7 181.3 351.8 152 328 152z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/kiss-beam.js
// module id = Oto1
// module chunks = 144